/**
 * Edge fade on the horizontally scrolling breadcrumb trail.
 *
 * Two classes are put on the wrapper and the stylesheet decides what to paint:
 *   is-scrollable  the trail is wider than its box, so there is something to scroll to
 *   is-scroll-end  the far end is in view, so the fade has nothing left to hint at
 *
 * This is JS rather than CSS because a scroll-driven animation would need its timeline
 * on an ancestor of the fade, and the fade sits on the wrapper while the scrolling
 * happens in the list beside it. `scroll(self)` is not available from there, and iOS
 * Safari only gained scroll-driven animations very recently in any case.
 *
 * The is-scrollable half also fixes something the static fade got wrong: a short trail
 * like "Forside › Produkter" fits easily, and used to be given a fade for nothing.
 */
(function () {
  function wire(wrapper) {
    const list = wrapper.querySelector('.breadcrumbs__list');
    if (!list) return;

    const update = () => {
      // 2px of slack: sub-pixel widths mean scrollLeft rarely lands exactly on the max.
      const max = list.scrollWidth - list.clientWidth;
      wrapper.classList.toggle('is-scrollable', max > 2);
      wrapper.classList.toggle('is-scroll-end', list.scrollLeft >= max - 2);
    };

    update();
    list.addEventListener('scroll', update, { passive: true });

    // The trail's width changes with the viewport, and with it whether it overflows at
    // all — a resize can turn the fade on or off without anyone scrolling.
    if (window.ResizeObserver) new ResizeObserver(update).observe(list);
    else window.addEventListener('resize', update);
  }

  document.querySelectorAll('.breadcrumbs').forEach(wire);
})();
